<!-- <button mat-raised-button (click)="retrieveReplacementClaims(filter)"><mat-icon>refresh</mat-icon>Refresh</button> -->
<div class="row" *ngIf="this.replacements.length > 0">
  <div class="col-md text-start">
    <h3>{{ pageTitle | translate }}</h3>
    <hr />
    <app-table id="REPLACEMENT_OVERVIEW" [data]="replacements" [search]="search" [pageSizes]="[5, 20, 50]" [headers]="columns"></app-table>
  </div>
</div>
